<template>
  <div class="page-content" style="margin-top: 20px">
    <el-row class="sign-manage-title search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">支付信息</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-div form-submit-page">
        <el-form ref="formInline" :model="formInline" label-width="120px" :rules="rules" class="box-content-form">
          <el-form-item label="选择公众号:" prop="original_id">
            <el-select v-model="formInline.original_id" placeholder="请选择公众号">
              <el-option
                v-for="item in publicNumber"
                :key="item.original_id"
                :label="item.nick_name"
                :value="item.original_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="AppID:" prop="app_id">
            <el-input v-model="formInline.app_id" placeholder="请输入AppID"></el-input>
          </el-form-item>
          <el-form-item label="商户ID:" prop="mch_id">
            <el-input v-model="formInline.mch_id" placeholder="请输入商户ID"></el-input>
          </el-form-item>
          <el-form-item label="秘钥:" prop="key">
            <el-input v-model="formInline.key" placeholder="请输入秘钥"></el-input>
          </el-form-item>
          <el-form-item label="证书文件:" prop="cert_path">
            <el-upload
              class="upload-demo"
              :action="upload"
              multiple
              name="file_upload"
              :limit="1"
              :show-file-list="false"
              :on-success="thumbSuccess">
              <label class="upload-btn" v-if="formInline.cert_path.length === 0">点击上传</label>
              <label class="upload-btn" v-if="formInline.cert_path.length !== 0">更换证书</label>
            </el-upload>
          </el-form-item>
          <el-form-item label="证书key文件:" prop="key_path">
            <el-upload
              class="upload-demo"
              :action="upload"
              multiple
              name="file_upload"
              :limit="1"
              :show-file-list="false"
              :on-success="thumbSuccessKey">
              <label class="upload-btn" v-if="formInline.key_path.length === 0">点击上传</label>
              <label class="upload-btn" v-if="formInline.key_path.length !== 0">更换证书key</label>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button class="confirm-btn" @click="submitForm('formInline')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { editPay, DetailPay, getWechatList } from '@/api/customer.js'
export default {
  name: 'wxPaymentAdd',
  data () {
    return {
      id: this.$route.query.id,
      formInline: {
        original_id: '',
        app_id: '',
        mch_id: '',
        key: '',
        cert_path: '',
        key_path: '',
        type: 2
      },
      API_HOST: API_HOST,
      publicNumber: [],
      certList: [],
      keyList: [],
      rules: {
        original_id: [
          { required: true, message: '请输入公众号', trigger: 'blur' }
        ],
        app_id: [
          { required: true, message: '请输入AppID', trigger: 'blur' }
        ],
        mch_id: [
          { required: true, message: '请输入商户ID', trigger: 'blur' }
        ],
        key: [
          { required: true, message: '请输入密钥', trigger: 'blur' }
        ],
        cert_path: [
          { required: true, message: '请上传证书文件', trigger: 'blur' }
        ],
        key_path: [
          { required: true, message: '请上传证书key文件', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    upload() {
      return API_HOST + '/admin/Upload/uploadcert'
    }
  },
  mounted () {
    this.getWechatList()
    if (typeof (this.id) !== 'undefined') {
      this.getById()
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editPay()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getWechatList() {
      getWechatList().then((res) => {
        if (res.data.code === 0) {
          this.publicNumber = res.data.data.list
        } else {
          _g.toastMsg('error', res.data.error)
        }
        console.log(res)
      })
    },
    getById() {
      let data = {
        id: this.id
      }
      DetailPay(data).then((res) => {
        console.log(res)
        if (res.data.code === 0) {
          this.formInline = res.data.data.info
          this.certList.push({
            name: this.formInline.cert_path
          })
          this.keyList.push({
            name: this.formInline.key_path
          })
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 添加
    editPay() {
      let data = this.formInline
      let status
      if (typeof (this.id) !== 'undefined') {
        data.id = this.id
        status = 1
      } else {
        status = 2
      }
      editPay(data, status).then((res) => {
        if (res.data.code === 0) {
          if (typeof (this.id) !== 'undefined') {
            _g.toastMsg('success', '编辑成功')
          } else {
            _g.toastMsg('success', '添加成功')
          }
          this.goBack()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    thumbSuccess(response, file, fileList) {
      _g.toastMsg('success', '文件上传成功')
      console.log(response)
      this.formInline.cert_path = response.data.path
    },
    thumbSuccessKey(response, file, fileList) {
      _g.toastMsg('success', '文件上传成功')
      console.log(response)
      this.formInline.key_path = response.data.path
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  created() {
  }
}
</script>

<style scoped>
.green{
  color: green;
}
.red{
  color: red;
}
.add-btn{
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-div {
  width: 100%;
  margin: 30px auto;
}
.box-content-form {
  margin-top: 10px;
  width: 530px !important;
  margin: 0 auto;
}
.box-content-form .el-form-item {
  width: 530px!important;
}
.upload-btn {
  color: #666;
}
</style>
